import React from 'react'
import FooterStyles from './Footer.styled'

const Footer = () => {
  return (
    <FooterStyles>
      <footer className="footer">
        <a
          href="https://claytonhomes.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="footLogo" />
          <div hidden>Clayton Homes Home Page</div>
        </a>
        <div className="legal">
          © 1998-{new Date().getFullYear()} CMH Services, Inc. All rights
          reserved. |{' '}
          <a
            href="https://claytonhomes.com/legal/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="legal-text">Legal</span>
          </a>{' '}
          |{' '}
          <a
            href="https://claytonhomes.com/privacy/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="privacy">Privacy</span>
          </a>{' '}
          |{' '}
          <a
            href="#"
            onClick={e => {
              e.preventDefault()
              window.Osano.cm.showDrawer('osano-cm-dom-info-dialog-open')
            }}
          >
            <span className="privacy">
              Do Not Sell or Share My Personal Information
            </span>
          </a>
        </div>
      </footer>
    </FooterStyles>
  )
}

export default Footer
